import React from 'react';
import type { ScrollSnapSlider } from 'scroll-snap-slider';

const ScrollSnapSliderContext = React.createContext({} as ScrollSnapSlider | undefined);

export default ScrollSnapSliderContext;
